import {RoleDto} from "@reside/reside-api-app";

/** List of tabs visible in administration menu. */
export const ADMINISTRATION_TABS: {
  name: string;
  /** Where does the tab lead to. */
  link: string;
  id: string;
  /** Roles allowed to see the tab. */
  roles: RoleDto.NameEnum[];
}[] = [
  {
    name: "Users",
    link: "/admin/users",
    id: "usersLink",
    roles: [
      "RESIDE_ADMIN",
      "ORGANIZATION_ADMIN",
      "FACILITY_ADMIN",
      "ADMISSIONS_DIRECTOR",
      "REGIONAL_ADMIN",
    ] as RoleDto.NameEnum[],
  },
  {
    name: "Organizations",
    link: "/admin/organizations",
    id: "organizationsLink",
    roles: ["RESIDE_ADMIN", "ORGANIZATION_ADMIN"] as RoleDto.NameEnum[],
  },
  {
    name: "Facility Settings",
    link: "/admin/facility/_/facility-settings",
    id: "facilitySettingsLink",
    roles: [
      "RESIDE_ADMIN",
      "ORGANIZATION_ADMIN",
      "FACILITY_ADMIN",
      "ADMISSIONS_DIRECTOR",
      "REGIONAL_ADMIN",
    ] as RoleDto.NameEnum[],
  },
  {
    name: "Feature Flags",
    link: "/admin/feature-flags",
    id: "featureFlagsLink",
    roles: ["RESIDE_ADMIN"] as RoleDto.NameEnum[],
  },
  {
    name: "Hub & Spoke",
    link: "/admin/hub-and-spoke",
    id: "hubAndSpokeLink",
    roles: ["RESIDE_ADMIN"] as RoleDto.NameEnum[],
  },
];
